import { Reference } from 'types/reference';

export enum LocaleSpecific {
  EN_US = 'en_US',
  EN_CA = 'en_CA',
  FR_CA = 'fr_CA',
  FR_FR = 'fr_FR',
  DE_DE = 'de_DE',
  EN_IE = 'en_IE',
  EN_NL = 'en_NL',
  EN_NO = 'en_NO',
  EN_SE = 'en_SE',
  EN_CH = 'en_CH',
  EN_GB = 'en_GB',
  EN_IT = 'en_IT',
  EN_DK = 'en_DK',
  EN_BE = 'en_BE',
  EN_AT = 'en_AT',
  EN_AU = 'en-AU',
  EN_ES = 'en-ES',

  BOTH = 'both',
}

export enum LocaleByPartnerCountry {
  CA = 'en_CA',
  US = 'en_US',
  FR = 'fr_FR',
  DE = 'de_DE',
  IE = 'en_IE',
  NL = 'en_NL',
  NO = 'en_NO',
  SE = 'en_SE',
  CH = 'en_CH',
  GB = 'en_GB',
  IT = 'en_IT',
  DK = 'en_DK',
  BE = 'en_BE',
  AT = 'en_AT',
  AU = 'en-AU',
  ES = 'en-ES',
}

export type FooterLinkProps = {
  name: string;
  reference: Reference;
  showLinkInSimpleFooter?: boolean;
  localeSpecific?: LocaleSpecific;
};

export type FooterColumnProps = {
  header: string;
  links: FooterLinkProps[];
};
